// extracted by mini-css-extract-plugin
export default {"block":"DiscountLabel_block__jN08q","inactive":"DiscountLabel_inactive__39yFA"};